import React, {forwardRef, useEffect, useRef, useState} from "react";
import useOrderStore from "./useOrderStore";
import Alert, {ERROR} from "../../components/v2/Alert";
import Button from "../../components/v2/Button";
import IconCarValidated from "../../assets/v2/badge-check.png";
import Input from "../../components/v2/Input";
import useValetStore from "../valet/hooks/useValetStore";
import {useTranslation} from "react-i18next";
import CarService from "../../services/CarService";
import FormatUtils from "../../utils/FormatUtils";
import CarCategoryView from "../../components/v2/CarCategoryView";

/* Inspiré de VehicleStep1 */
function VehicleValidate({
                             previousBtn,
                             nextBtn,
                         }, ref) {

    const {t} = useTranslation('common');

    const [successVehicleData, setSuccessVehicleData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [vin, setVin] = useState("");

    // Vieux hack
    const successVehicleDataRef = useRef(null);
    successVehicleDataRef.current = successVehicleData;

    const {
        callPost,
    } = useValetStore();

    const {
        vehicleId,
        setActiveStep,
        setVehicle
    } = useOrderStore();

    useEffect(() => {
        // NB La logique du back est géré par ServiceModal::previousClickedHandler
        previousBtn.current.style.display = '';
        nextBtn.current.style.display = '';

        nextBtn.current.addEventListener('click', nextClickedHandler);
        return () => {
            if (nextBtn.current) {
                nextBtn.current.removeEventListener('click', nextClickedHandler);
            }
        }
    }, [])

    const nextClickedHandler = () => {
        if (successVehicleDataRef.current == null) {
            setErrorMessage(t('service.step_vehicle_validate.verify_vehicle'));
            return;
        }
        setVehicle(successVehicleDataRef.current);
        setActiveStep(1);
    }

    const checkVin = () => {
        setErrorMessage(null);
        if (vin.length < 17) {
            setErrorMessage(t('vehicle.form.vin_error_incorrect'));
            return;
        }

        callPost('vin_check', {
            id: vehicleId,
            vin: vin
        }, (resultData) => {
            setSuccessVehicleData(resultData.vehicle);
        }, (resultFailData) => {
            if (resultFailData.message == 'vehicle.form.error.vin_already_registered') {
                let text = FormatUtils.changeTextWithValues(t(resultFailData.message), resultFailData.message_values)
                setErrorMessage(text)
                return;
            } else {
                setErrorMessage(t('service.step_vehicle_validate.wrong_vin'));
            }
        });
    }

    const getCarLabel = () => {
        let carCategory = CarService.getCarCategoryById(successVehicleData.car_category_id);
        let label = successVehicleData.brand + ' ' + successVehicleData.model + " [" + t(carCategory.label) + "]";
        return label;
    }


    return (
        <div className="font-DMSans h-full flex flex-col p-4 gap-4">
            <div className="text-white text-[30px] font-bold">
                {t('service.step_vehicle_validate.title')}
            </div>
            <div>
                {t('service.step_vehicle_validate.description')}
            </div>
            <div className="flex content-center items-center">
                <img src={IconCarValidated} className="w-[50px] h-[50px]"/>
                <div className="">
                    {t('service.step_vehicle_validate.description2')}
                </div>
            </div>

            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                <legend className="text-sm">&nbsp;{t('service.step_vehicle_validate.vin_label')} &nbsp;</legend>
                <Input
                    label={t('service.step_vehicle_validate.vin_label2')}
                    id="vin"
                    placeholder={t('service.step_vehicle_validate.vin_example')}
                    value={vin}
                    onChange={(value) => setVin(value)}/>
                <div className="m-2"></div>
                <Button text={t('service.step_vehicle_validate.vin_button')} clickHandler={checkVin}/>
            </fieldset>

            {successVehicleData ?
                <>{t('service.step_vehicle_validate.found')}
                    <CarCategoryView categoryId={successVehicleData.car_category_id}/>
                    <b>{getCarLabel()}</b>
                </>
                : null}

            {errorMessage != null ?
                <Alert type={ERROR}
                       label={t('service.common.error_label')}
                       text={errorMessage}
                /> : null
            }
        </div>
    );
}

export default forwardRef(VehicleValidate);